import { type TemplateType } from '~/types/template';

export const templateType = {
  DYNAMIC_PAGE: 'DYNAMIC_PAGE',
  LANDING_PAGE: 'LANDING_PAGE',
} as const satisfies Record<TemplateType, TemplateType>;
